/*
 * Tile to show on the integration page
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, Typography
} from '@mui/material';

import CheckCircle from '@mui/icons-material/CheckCircle';
import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';

import AppLogo from '../ui/AppLogo';


import { green, red } from '@mui/material/colors';


const styleSheet = theme => ({
    paper: {
      width: 340,
      height: 108,
      marginTop: theme.spacing(3),
      //overflow: 'auto',
      padding: 20,
      '&:hover': {
          backgroundColor: '#f7f7f7',
          cursor: 'pointer'
      }
    },
    appLogo: {
      float: 'left',
      marginRight: 15
    },
    appDescription: {
      float: 'left',
      maxWidth: 230,
      [theme.breakpoints.up('xs')]: {
        /* subtract width of the other 2 columns + the margins */
        width: 'calc(100% - 48px - 15px - 15px - 24px)',
      },
      [theme.breakpoints.up('sm')]: {
        width: 230,
      },
    },
    appStatus: {
      float: 'right',
      marginTop: 4,
      clear: 'right',
    },
    // not used on this page
    // avatar: {
    //     marginRight: 20,
    //     float: 'left',
    //     backgroundColor: theme.palette.secondary.light,
    //     color: theme.palette.text.secondary
    // },
    appTitle: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    skuName: {
        color: 'inherit'
    },
    description: {
        color: '#666666'
    }
});

class IntegrationTile extends Component {

    goTo(url) {
        this.props.history.push(`${url}`);
    }

    connectToApp() {
        // Want a redirect here, so use history replace.
        // Get the redirect uri from our internal API
        const { callPartnerApi } = this.props.auth;
        const app = this.props.app;

        let payload;
        if (app === 'custom') {
            let theUrl = "integrationapi";
            this.goTo(theUrl);
            return;
        } else if (app.accountDelegatedAuthsId != null) {
            if (app.appName === 'Xero') {
                // Go to the xero integration setup page
                let theUrl = "./integrationxero?adaId=" + app.accountDelegatedAuthsId;
                this.goTo(theUrl);
                return;
            } else if (app.appName === 'QuickBooks') {
                // Go to the qbo integration setup page
                let theUrl = "./integrationqbo?adaId=" + app.accountDelegatedAuthsId;
                this.goTo(theUrl);
                return;
            } else if (app.appName === 'FreshBooks') {
                // Go to the freshbooks integration setup page]
                let theUrl = "./integrationfb?adaId=" + app.accountDelegatedAuthsId;
                this.goTo(theUrl);
                return;
            } else if (app.appName === 'Recurly') {
                // Go to the recurly integration setup page
                let theUrl = "./integrationrecurly?adaId=" + app.accountDelegatedAuthsId;
                this.goTo(theUrl);
                return;
            }

            payload = {
                operation: "OAuth2Revoke",
                params: {
                    accountDelegatedAuthsId:  app.accountDelegatedAuthsId
                }
            };
        } else {
            payload = {
                operation: "OAuth2PartnerRedirect",
                params: {
                  appIntegrationId:  app.appIntegrationId
                }
            };
        }    
    
        Promise.resolve()
        .then(() => {
            return callPartnerApi('appbind/generic',
                                  'POST',
                                  payload);
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
          if (data.link) {
            window.location.replace(data.link);
          } else {
            window.location.reload();
          }
        })
        .catch(err => {
          // console.log('err');
          window.location.reload();
        });
    }
    
    render() {
        const statusOk = green[300];
        const statusInactive = red[300];
        const app = this.props.app;
        const classes = this.props.classes;

        // let theUrl = "./integration?integrationAppId=" + app.integrationAppId;
        if (app === 'custom') {
            return (
                <div>
                    <Paper elevation={2} className={classes.paper}>
                        <Grid container spacing={1} direction="row" justifyContent="flex-start">
                            <Grid item xs={2}>
                                <AppLogo logoPath='/logos/appbind-160t.png' appName="Custom AppBind integrations" imageHeight='48px'/>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography className={classes.appTitle} variant="h6">Custom AppBind integrations</Typography>
                                <Typography variant="body2" className={classes.description}>Configure your own customer AppBind integrations using AppBind's external API</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justifyContent="space-around">
                                    <Grid item style={{marginTop: '8px'}}>
                                        <Button color="primary" variant="outlined" onClick={()=> {this.connectToApp()}}>Manage custom integrations</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </div>
            );
        } else {
            let buttonLabel = "Connect to " + app.appName;
            let theDescription = app.appDescription;
            if (app.accountDelegatedAuthsId != null) {
                /*
                if (app.appName === 'Xero') {
                    buttonLabel = "Manage integration with " + app.appName;
                } else {
                buttonLabel = "Disconnect from " + app.appName;
                }
                */
                buttonLabel = "Manage integration with " + app.appName;

                // Get the connected info
                if (app.appData) {
                    if (app.appName === 'Xero') {
                        let adJson = JSON.parse(app.appData);
                        let aTenant = adJson.body[0];
                        let tenantName = aTenant.tenantName;
                        theDescription = theDescription + ' ' + tenantName;
                    } else if (app.appName === 'QuickBooks') {
                        let adJson = JSON.parse(app.appData);
                        // let theRealm = adJson.realmId;
                        let companyName = adJson.CompanyInfo[0].CompanyName;
                        theDescription = theDescription + ' ' + companyName;
                    }
                }
            }

            return (
                <div>
                    <Paper elevation={2} className={classes.paper}>
                        <Grid container spacing={1} direction="row" justifyContent="flex-start">
                            <Grid item xs={2}>
                                <AppLogo logoPath={app.appLogo} appName={app.appName} imageHeight='48px'/>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className={classes.appTitle} variant="h6">{app.appName}</Typography>
                                <Typography variant="body2" className={classes.description}>{theDescription}</Typography>
                            </Grid>
                            <Grid item xs={1}>
                                { app.accountDelegatedAuthsId != null &&
                                <CheckCircle htmlColor={statusOk}/>}
                                { app.accountDelegatedAuthsId == null &&
                                <PauseCircleFilled htmlColor={statusInactive}/>}
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justifyContent="space-around">
                                    <Grid item style={{marginTop: '8px'}}>
                                        <Button color="primary" variant="outlined" onClick={()=> {this.connectToApp()}}>{buttonLabel}</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </div>
            );
        }
    }
}

export default withStyles(styleSheet)(IntegrationTile);
